import TEMPLATE_URL from "emun.products/lists/product-list-prompt.htm";
import controller from "emun.products/lists/product-list-prompt.controller";
import modals from "webmodals/modals";

const NOOP = () => {};

export default ({
  size = "xs",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  simple = false,
  request: {
    id,
    label,
    description,
    tags = [],
    expiresOn,
    visibility = [],
    retailerAuthorization = {}
  } = {},
  action = id ? "Update" : "Create",
  retailerId,
  hideRetailer = simple || !!retailerId,
  title = hideRetailer ? `${action} Wishlist` : `${action} Product List`,
  hideNonRetailer = false,
  view = "cards",
  onToggle = NOOP,
  onProductSelected = NOOP,
  onProductDeselected = NOOP
} = {}) =>
  modals.open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        title,
        onProductSelected,
        onProductDeselected,
        retailerId,
        hideRetailer,
        hideNonRetailer,
        view,
        simple,
        request: {
          id,
          label,
          description,
          tags: [...tags],
          visibility: [...visibility],
          expiresOn,
          retailerAuthorization: Object.assign({}, retailerAuthorization)
        }
      })
    }
  }).result;
